<div class="position-reletivediv main-div-start">
  <div class="popup-inner-space">
    <div class="text-right d-flex justify-content-between pb-1">
      <h4 id="heading-control" class="right-sidebar-heading color_black mb-0" id="dashboard-main">IOT Configuration</h4>
      <img src="assets/images/close_icon.svg" class="img-fluid closeicon closeicon2 cursor-pointer tab-close" alt="..."
        (click)="Close()" />
    </div>
  </div>
  <mat-tab-group (selectedTabChange)="onTabChanged($event);" class="text-field-container-main">
    <mat-tab label="Configuration" [aria-label]="'bgConfiguration'" id="tabGsmconfigconfiguration">
      <div class="errmsg fix-error-message additionalmsgstyle" *ngIf="errorMsg">
        {{errorMsg}}
      </div>
      <div class="sucessmsg fix-error-message additionalmsgstyle" *ngIf="successMsg">
        {{successMsg}}</div>
      <form [formGroup]="gsmconfigForm" [ngStyle]="{'margin-top.px': successMsg ? 25 : 0}"
        class="width100 gsmconfigForm-container table-wrapper-scroll-y my-custom-scrollbar ">



        <div class="row text-field-container2">
          <div class="fxg-field col-lg-12">
            <div class="betweenheader12 betweenheader11">
              GSM Device Parameters
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <mat-select (selectionChange)="Ondevice($event.value)" name="Type" id="dtype" formControlName="dtype"
              required="" aria-required="true" class="width-reduce-popup">
              <mat-option value="">(Select Device Type)</mat-option>
              <mat-option MatFormFieldControl="dtype" *ngFor="let lstdevicetype of DeviceTypeList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div>
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.dtype">
                {{displayMessage1.dtype}}
              </p>
            </div>
          </div>



          <div class="fxg-field margin-top-5 col-lg-6 padding-space" *ngIf="MasterSlave == 0">
            <label style="display:none;" class="Navuser">Max. Slave on Serial
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required maxium-shelve-input sessioncamexclude width-reduce-popup"
              name="Maxslav" formControlName="Maxslav" (keyup)="onKeypressEvent($event, 'Slave')" id="Maxslav"
              required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
              data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Max. Slave on
              Serial</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.Maxslav">
                {{displayMessage1.Maxslav}}
              </p>
              <p class="error_msg error-sms-Interval" *ngIf="SlaveValMessage">{{SlaveValMessage}}</p>
            </div>
          </div>



          <div class="fxg-field margin-top-5 col-lg-6 padding-space" *ngIf="MasterSlave == 1">
            <label style="display:none;" class="Navuser">Slave ID
            </label>
            <input type="text"
              class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Slvid"
              formControlName="Slvid" (keyup)="onKeypressEvent($event, 'SlaveID')" id="Slvid" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
              data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Maximum Slave</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.Slvid">
                {{displayMessage1.Slvid}}
              </p>
              <p class="error_msg error-sms-Interval" *ngIf="SlaveMessage">{{SlaveMessage}}</p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Max. Analog Input Channels
            </label>
            <mat-select (blur)="blur()" name="MaxAnalogDevice" id="MaxAnalogDevice" formControlName="MaxAnalogDevice"
              required="" aria-required="true" class="width-reduce-popup">
              <mat-option value="">(Select Max. Analog Input Channels)</mat-option>
              <mat-option value="1">1</mat-option>
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
              <mat-option value="6">6</mat-option>
              <mat-option value="7">7</mat-option>
              <mat-option value="8">8</mat-option>
            </mat-select>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.MaxAnalogDevice">
                  {{displayMessage1.MaxAnalogDevice}}
                </p>
              </div>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Analog Scaling Decimal Point
            </label>
            <mat-select name="AnalogScalingDecimalPoint" formControlName="AnalogScalingDecimalPoint"
              id="AnalogScalingDecimalPoint" class="width-reduce-popup">
              <mat-option value="">(Select Analog Scaling Decimal Point)</mat-option>
              <mat-option MatFormFieldControl="AnalogScalingDecimalPoint"
                *ngFor="let lstdevicetype of AnalogScalingDecimalPointList" [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.AnalogScalingDecimalPoint">
                {{displayMessage1.AnalogScalingDecimalPoint}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Baudrate
            </label>
            <mat-select name="brate" formControlName="brate" id="brate" class="width-reduce-popup">
              <mat-option value="">(Select Baudrate)</mat-option>
              <mat-option MatFormFieldControl="brate" *ngFor="let lstdevicetype of BaudrateList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.brate">
                {{displayMessage1.brate}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Serial Data Bits
            </label>
            <mat-select name="SerialDataBits" id="SerialDataBits" formControlName="SerialDataBits"
              class="width-reduce-popup">
              <mat-option value="">(Select Serial Data Bits)</mat-option>
              <mat-option MatFormFieldControl="SerialDataBits" *ngFor="let lstdevicetype of SerialDataBitsList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.SerialDataBits">
                {{displayMessage1.SerialDataBits}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Parity
            </label>
            <mat-select name="parity" formControlName="prty" id="prty" class="width-reduce-popup">
              <mat-option value="" class="width-reduce-popup">(Select Parity)</mat-option>
              <mat-option MatFormFieldControl="prty" *ngFor="let lstdevicetype of ParityList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.prty">
                  {{displayMessage1.prty}}
                </p>
              </div>
            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Interval Timer - Field Instrument Timer(Sec)
            </label>
            <input type="text"
              class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="intm"
              id="intm" formControlName="intm" (keyup)="onKeypressEvent($event, 'IntervalTime')" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Interval Timer - Field
              Instrument Timer(Sec)</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.intm">
                {{displayMessage1.intm}}
              </p>
              <p class="error_msg  error-sms-Interval" *ngIf="InTimeMessage">{{InTimeMessage}}</p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">APN
            </label>
            <mat-select name="apnname" id="apnname" formControlName="apn" class="width-reduce-popup">
              <mat-option value="">(Select APN)</mat-option>
              <mat-option MatFormFieldControl="prty" *ngFor="let lstdevicetype of APNList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.apn">
                {{displayMessage1.apn}}
              </p>

            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">HTTP URL
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              formControlName="URL" id="UnitRate" name="UnitRate" title="Price Input" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">HTTP URL</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.URL">
                {{displayMessage1.URL}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">HTTP Port
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required width-reduce-popup sessioncamexclude" name="port"
              id="port" formControlName="port" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}" OnlyNumber>
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">HTTP Port</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.port">
                {{displayMessage1.port}}
              </p>
              <p class="error_msg error-sms-Interval" *ngIf="PORTMessage">{{PORTMessage}}</p>
            </div>
          </div>



          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">MQTT Key ID
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" name="kid"
              disabled="true" id="kid" formControlName="kid" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1"
              style="margin-top: -2%;">MQTT Key ID</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.kid">
                {{displayMessage1.kid}}
              </p>
            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Device Datalog Selection
            </label>
            <mat-select name="dls" id="dls" formControlName="dls" class="width-reduce-popup">
              <mat-option value="">(Select Device Datalog Selection)</mat-option>
              <mat-option MatFormFieldControl="dls" *ngFor="let lstdevicetype of DataLogSelectionList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.dls">
                {{displayMessage1.dls}}
              </p>

            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">CNMP
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" name="cnmp"
              (input)="onCNMPChange($event,'cnmp')" id="cnmp" formControlName="cnmp" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">CNMP</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.cnmp">
                {{displayMessage1.cnmp}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Start Time
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" name="strtm"
              id="strtm" formControlName="strtm" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Start Time</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.strtm">
                {{displayMessage1.strtm}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">SMS Interval Time
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" name="smstm"
              id="smstm" formControlName="smstm" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">SMS Interval
              Time</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.smstm">
                {{displayMessage1.smstm}}
              </p>
            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Device Datalog Mode
            </label>
            <mat-select name="dlm" id="dlm" formControlName="dlm" class="width-reduce-popup">
              <mat-option value="">(Select Device Datalog mode)</mat-option>
              <mat-option MatFormFieldControl="dlm" *ngFor="let lstdevicetype of DataLogList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.dlm">
                {{displayMessage1.dlm}}
              </p>

            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">SMS Mode
            </label>
            <mat-select name="smsmode" id="smsmode" formControlName="smsmode" class="width-reduce-popup">
              <mat-option value="">(Select SMS Mode)</mat-option>
              <mat-option MatFormFieldControl="smsmode" *ngFor="let lstdevicetype of SMSModeList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.smsmode">
                {{displayMessage1.smsmode}}
              </p>

            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">JSON Datatype
            </label>
            <mat-select name="jdt" id="jdt" formControlName="jdt" class="width-reduce-popup">
              <mat-option value="">(Select JSON Datatype)</mat-option>
              <mat-option MatFormFieldControl="jdt" *ngFor="let lstdevicetype of JSONdatatypeList"
                [value]="lstdevicetype.CodeDescription">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.jdt">
                {{displayMessage1.jdt}}
              </p>

            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Server
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="Server" id="Server" formControlName="Server" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Server</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.Server">
                {{displayMessage1.Server}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Resource
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="Resource" id="Resource" formControlName="Resource" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Resource</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.Resource">
                {{displayMessage1.Resource}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Data Post Type
            </label>
            <mat-select name="DataPostType" id="DataPostType" formControlName="DataPostType" class="width-reduce-popup">
              <mat-option value="">(Select Data Post Type)</mat-option>
              <mat-option MatFormFieldControl="DataPostType" *ngFor="let lstdevicetype of DataPostTypeList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.DataPostType">
                {{displayMessage1.DataPostType}}
              </p>
            </div>
          </div>






          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Data Post Protocol
            </label>
            <mat-select name="DataPostProtocol" id="DataPostProtocol" formControlName="DataPostProtocol"
              class="width-reduce-popup">
              <mat-option value="">(Select Data Post Protocol)</mat-option>
              <mat-option MatFormFieldControl="DataPostProtocol" *ngFor="let lstdevicetype of DataPostProtocolList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.DataPostProtocol">
                {{displayMessage1.DataPostProtocol}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">HTTP Data Post Port
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" [min]="0"
              name="HttpDataPostPort" id="HttpDataPostPort" formControlName="HttpDataPostPort" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Http Data Post
              Port</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.HttpDataPostPort">
                {{displayMessage1.HttpDataPostPort}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Relay On Time
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" [min]="0"
              name="RelayOnTime" id="RelayOnTime" formControlName="RelayOnTime" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Relay On Time</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.RelayOnTime">
                {{displayMessage1.RelayOnTime}}
              </p>
            </div>
          </div>



          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">TCP Data Post Port
            </label>
            <input type="number"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="TcpDataPostPort" id="TcpDataPostPort" formControlName="TcpDataPostPort" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">TCP Data Post
              Port</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.TcpDataPostPort">
                {{displayMessage1.TcpDataPostPort}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Data Read Type
            </label>
            <mat-select name="DataReadType" id="DataReadType" formControlName="DataReadType" class="width-reduce-popup">
              <mat-option value="">(Select Data Read Type)</mat-option>
              <mat-option MatFormFieldControl="DataReadType" *ngFor="let lstdevicetype of DataReadTypeList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.DataReadType">
                {{displayMessage1.DataReadType}}
              </p>

            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">MQTT Connection Check
            </label>
            <mat-select name="MqttConnectionCheck" id="MqttConnectionCheck" formControlName="MqttConnectionCheck"
              class="width-reduce-popup">
              <mat-option value="">(Select MQTT Connection Check)</mat-option>
              <mat-option MatFormFieldControl="MqttConnectionCheck"
                *ngFor="let lstdevicetype of MqttConnectionCheckList" [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.MqttConnectionCheck">
                {{displayMessage1.MqttConnectionCheck}}
              </p>

            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">ASCII String Type
            </label>
            <mat-select name="AsciiStringType" id="AsciiStringType" formControlName="AsciiStringType"
              class="width-reduce-popup">
              <mat-option value="">(Select ASCII String Type)</mat-option>
              <mat-option MatFormFieldControl="AsciiStringType" *ngFor="let lstdevicetype of AsciiStringTypeList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">

              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.AsciiStringType">
                {{displayMessage1.AsciiStringType}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">HTTP Auth
            </label>
            <mat-select name="HttpAuth" id="HttpAuth" formControlName="HttpAuth" class="width-reduce-popup"
              (selectionChange)="HttpAuthChange($event)">
              <mat-option value="">(Select HTTP Auth)</mat-option>
              <mat-option MatFormFieldControl="HttpAuth" *ngFor="let lstdevicetype of HttpAuthList"
                [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>

            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.HttpAuth">
                {{displayMessage1.HttpAuth}}
              </p>
            </div>
          </div>
          <div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space" *ngIf="showvalue==true">
            <label style="display:none;" class="Navuser">HTTP Username
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="HttpUsername" id="HttpUsername" formControlName="HttpUsername" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Http Username</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.HttpUsername">
                {{displayMessage1.HttpUsername}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space" *ngIf="showvalue==true">
            <label style="display:none;" class="Navuser">HTTP Password
            </label>
            <input type="password"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="HttpPassword" id="HttpPassword" formControlName="HttpPassword" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Http Password</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.HttpPassword">
                {{displayMessage1.HttpPassword}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">WiFi SSID
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="WiFiSSID" id="WiFiSSID" formControlName="WiFiSSID" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">WiFi SSID</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.WiFiSSID">
                {{displayMessage1.WiFiSSID}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">WiFi Password
            </label>
            <input type="password"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="WiFiPassword" id="WiFiPassword" formControlName="WiFiPassword" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">WiFi Password</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.WiFiPassword">
                {{displayMessage1.WiFiPassword}}
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="fxg-field margin-top-5 col-lg-12">
            <div class="betweenheader12">Ethernet HTTP Post</div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Post Server
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="PostServer" id="PostServer" formControlName="PostServer" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Post Server</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.PostServer">
                {{displayMessage1.PostServer}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Post Resource
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="PostResource" id="PostResource" formControlName="PostResource" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Post Resource</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.PostResource">
                {{displayMessage1.PostResource}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Post Port Number
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="PostPortNumber" id="PostPortNumber" formControlName="PostPortNumber" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Post Port Number</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.PostPortNumber">
                {{displayMessage1.PostPortNumber}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Ethernet HTTP Post Check
            </label>
            <mat-select name="EthernetHTTPPostCheck" id="EthernetHTTPPostCheck" formControlName="EthernetHTTPPostCheck"
              class="width-reduce-popup">
              <mat-option value="">(Select Ethernet HTTP Post Check)</mat-option>
              <mat-option MatFormFieldControl="EthernetHTTPPostCheck"
                *ngFor="let lstdevicetype of EthernetHTTPPostCheckList" [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.EthernetHTTPPostCheck">
                {{displayMessage1.EthernetHTTPPostCheck}}
              </p>
            </div>
          </div>


          <div class="fxg-field margin-top-5 col-lg-12">
            <div class="betweenheader12">Ethernet HTTP Get</div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Get Server
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="GetServer" id="GetServer" formControlName="GetServer" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Get Server</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.GetServer">
                {{displayMessage1.GetServer}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Get Resource
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="GetResource" id="GetResource" formControlName="GetResource" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Get Resource</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.GetResource">
                {{displayMessage1.GetResource}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Get Port Number
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="GetPortNumber" id="GetPortNumber" formControlName="GetPortNumber" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Get Port Number</span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.GetPortNumber">
                {{displayMessage1.GetPortNumber}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Ethernet HTTP Get Check
            </label>
            <mat-select name="EthernetHTTPGetCheck" id="EthernetHTTPGetCheck" formControlName="EthernetHTTPGetCheck"
              class="width-reduce-popup">
              <mat-option value="">(Select Ethernet HTTP Get Check)</mat-option>
              <mat-option MatFormFieldControl="EthernetHTTPGetCheck"
                *ngFor="let lstdevicetype of EthernetHTTPGetCheckList" [value]="lstdevicetype.CodeValue">
                {{lstdevicetype.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.EthernetHTTPGetCheck">
                {{displayMessage1.EthernetHTTPGetCheck}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-12">
            <div class="betweenheader12">FTP Parameters</div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6 padding-space space-manage">
            <label style="display:none;" class="Navuser">>Username
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" type="text"
              name="FTPUsername" id="FTPUsername" formControlName="FTPUsername" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}" data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Username</span>
            <div>
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.FTPUsername">
                {{displayMessage1.FTPUsername}}
              </p>
            </div>
          </div>

          <div class="fxg-field margin-top-5 col-lg-6 padding-space space-manage">
            <label style="display:none;" class="Navuser">Password
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" type="text"
              name="FTPPassword" id="FTPPassword" formControlName="FTPPassword" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Password</span>
            <div>
              <p class="error_msg" *ngIf="displayMessage1.FTPPassword">
                {{displayMessage1.FTPPassword}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space space-manage">
            <label style="display:none;" class="Navuser">CSV File Name
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="CSVFileName" id="CSVFileName" formControlName="CSVFileName" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">CSV File Name</span>
            <div>
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.CSVFileName">
                {{displayMessage1.CSVFileName}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space space-manage">
            <label style="display:none;" class="Navuser">Directory Path
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="DirectoryPath" id="DirectoryPath" formControlName="DirectoryPath" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Directory Path</span>
            <div>
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage1.DirectoryPath">
                {{displayMessage1.DirectoryPath}}
              </p>
            </div>
          </div>

        </div>

      </form>
      <div class="margin-top-20 button-fix-bottom save-cancel float-right-btn" *ngIf="DisplayButton">
        <button class="btncommon  width-fix67" (click)="OnSubmitConfig()" id="btngsmconfigSave">Save</button>
        <button class="btn-orange btncommon btn-orange-SendToMail12  width-fix67" (click)="PublishGSMJson()"
          id="btngsmconfigSend">Send</button>
        <button class="btncommon-grey btn-border-add-company  width-fix67" (click)="OnCancel()"
          id="btngsmconfigCancel">Cancel</button>
      </div>
    </mat-tab>
    <mat-tab label="RTC" [aria-label]="'bgRTC'" id="tabGsmconfigconfiguration">

      <form [formGroup]="RTCconfigForm"
        class="width100 gsmconfigForm-container r table-wrapper-scroll-y my-custom-scrollbar ">
        <div class="errmsg fix-error-message " *ngIf="errorMsg">
          {{errorMsg}}
        </div>
        <div class="sucessmsg fix-error-message " *ngIf="successMsg">
          {{successMsg}}</div>
        <div class="row text-field-container2">
          <div class="fxg-field col-lg-12">
            <div class="betweenheader12 betweenheader11">SET RTC</div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">TimeZone
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="slaveid" formControlName="TimeZone" id="TimeZone" (keyup)="onKeypressEvent($event, 'TimeZone')"
              id="Maxslav" required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
              data-errmsg="Sorry, this is a required field." TimeZone>
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">TimeZone </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage2.TimeZone">
                {{displayMessage2.TimeZone}}
              </p>
              <p class="error_msg error-sms-Interval" *ngIf="TimeZoneMessage">{{TimeZoneMessage}}</p>
            </div>
          </div>

        </div>
        <div class="row">

          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">DateTime
            </label>
            <mat-form-field class="calendar date-choose33 width-reduce-popup">
              <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a Date & Time"
                formControlName="DateTime" [readonly]="IsreadOnly">

              <mat-datepicker-toggle matSuffix [for]="picker" class="picker-icon"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
            </mat-form-field>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage2.DateTime">
                {{displayMessage2.DateTime}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <button class="btncommon rtc-get" type="button" (click)="GetDatetime()" id="btngsmconfifGet">Get</button>
          </div>
        </div>
      </form>
      <div class="gsm-popup">
        <button class="btncommon width-fix67 margin-top-20" type="button" (click)="ResetDevice('303')"
          id="btngsmconfigSave" style="margin-right: 1%;">Pointer
          Reset</button>
        <button class="btncommon width-fix67 margin-top-20" type="button" (click)="ResetDevice('202')"
          id="btngsmconfigSave" style="margin-right: 1%;">Para.
          Update</button>
        <button class="btncommon width-fix67 margin-top-20" type="button" (click)="ResetDevice('101')"
          id="btngsmconfigSave">Restart
          Device</button>
        <div class="margin-top-20  button-fix-bottom save-cancel float-right-btn" *ngIf="DisplayButton">
          <button class="btncommon width-fix67" (click)="OnSubmitRTC()" id="btngsmconfigSave">Save</button>
          <button class="btn-orange btncommon btn-orange-SendToMail12 width-fix67" (click)="PublishRTCJson()"
            id="btngsmconfigSend">Send</button>
          <button class="btncommon-grey btn-border-add-company width-fix67" (click)="OnCancel()"
            id="btngsmconfigCancel">Cancel</button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Ethernet Settings" [aria-label]="'bgEthernetSettings'" id="tabEthernetSettings">

      <form [formGroup]="EthernetSettingsForm" class="width100">
        <div class="errmsg fix-error-message additionalmsgstyle" *ngIf="errorMsg">
          {{errorMsg}}
        </div>
        <div class="sucessmsg fix-error-message additionalmsgstyle" *ngIf="successMsg">
          {{successMsg}}</div>

        <!-- <div class="row text-field-container2"> -->
        <div class="fxg-field col-lg-12">
          <div class="betweenheader12 betweenheader11">
            Ethernet Settings
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">IP Address
          </label>
          <input type="text"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Ip"
            id="Ip" formControlName="Ip" (keyup)="onKeypressEvent($event, 'Ip')" required="" aria-required="true"
            [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">IP Address</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.Ip">
              {{displayMessage4.Ip}}
            </p>
            <mat-error class="error_msg error-sms-Interval"
              *ngIf="EthernetSettingsForm.get('Ip').errors?.invalidIpAddress">
              Invalid IP Address
            </mat-error>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">Subnet
          </label>
          <input type="text"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Subnet"
            id="Subnet" formControlName="Subnet" (keyup)="onKeypressEvent($event, 'Subnet')" required=""
            aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Subnet</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.Subnet">
              {{displayMessage4.Subnet}}
            </p>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">DNS
          </label>
          <input type="text"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Dns"
            id="Dns" formControlName="Dns" (keyup)="onKeypressEvent($event, 'Dns')" required="" aria-required="true"
            [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">DNS</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.Dns">
              {{displayMessage4.Dns}}
            </p>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">Port
          </label>
          <input type="number"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Port"
            id="Port" formControlName="Port" (keyup)="onKeypressEvent($event, 'Port')" required="" aria-required="true"
            [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Port</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.Port">
              {{displayMessage4.Port}}
            </p>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">Gateway
          </label>
          <input type="text"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="Gateway"
            id="Gateway" formControlName="Gateway" (keyup)="onKeypressEvent($event, 'Gateway')" required=""
            aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Gateway</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.Gateway">
              {{displayMessage4.Gateway}}
            </p>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-12">
          <div class="betweenheader12">Modbus TCP IP & Port</div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">IP Address
          </label>
          <input type="text"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude"
            name="IpAddress" id="IpAddress" formControlName="IpAddress" (keyup)="onKeypressEvent($event, 'IpAddress')"
            required="" aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">IpAddress</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.IpAddress">
              {{displayMessage4.IpAddress}}
            </p>
            <mat-error class="error_msg error-sms-Interval"
              *ngIf="EthernetSettingsForm.get('IpAddress').errors?.invalidIpAddress">
              Invalid IP Address
            </mat-error>
          </div>
        </div>
        <div class="fxg-field margin-top-5 col-lg-6 padding-space">
          <label style="display:none;" class="Navuser">TCP Port
          </label>
          <input type="number"
            class="width-reduce-popup fxg-field__input-text fxg-field__input--required sessioncamexclude" name="TcpPort"
            id="TcpPort" formControlName="TcpPort" (keyup)="onKeypressEvent($event, 'TcpPort')" required=""
            aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
          <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">TCP Port</span>
          <div style="position: relative;">
            <p class="error_msg error-sms-Interval" *ngIf="displayMessage4.TcpPort">
              {{displayMessage4.TcpPort}}
            </p>
          </div>
        </div>
      </form>
      <div class="margin-top-20 button-fix-bottom save-cancel float-right-btn" *ngIf="DisplayButton">
        <button class="btncommon  width-fix67" (click)="OnSubmitEthernetConfig()" id="btngsmconfigSave">Save</button>
        <button class="btn-orange btncommon btn-orange-SendToMail12  width-fix67" (click)="PublishEthernetJson()"
          id="btngsmconfigSend">Send</button>
        <button class="btncommon-grey btn-border-add-company  width-fix67" (click)="OnCancel()"
          id="btngsmconfigCancel">Cancel</button>
      </div>
    </mat-tab>
    <mat-tab label="Settings" [aria-label]="'bgSettings'" id="tabGsmconfigconfiguration">
      <form [formGroup]="MqttSettingsForm"
        class="width100 gsmconfigForm-container r table-wrapper-scroll-y my-custom-scrollbar">
        <div class="errmsg fix-error-message " *ngIf="errorMsg">
          {{errorMsg}}
        </div>
        <div class="sucessmsg fix-error-message " *ngIf="successMsg">
          {{successMsg}}</div>
        <div class="row text-field-container2">
          <div class="fxg-field col-lg-12">
            <div class="betweenheader12 betweenheader11">MQTT Settings</div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6">
            <label style="display:none;" class="Navuser">Protocol
            </label>
            <mat-select name="protocol" id="protocol" formControlName="protocol" class="width-reduce-popup">
              <mat-option value="" class="width-reduce-popup">(Select Protocol)</mat-option>
              <mat-option MatFormFieldControl="protocol" *ngFor="let lstdeviceprotocol of DeviceProtocolList"
                [value]="lstdeviceprotocol.CodeDescription">
                {{lstdeviceprotocol.CodeDisplayName}}
              </mat-option>
            </mat-select>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.protocol">
                {{displayMessage3.protocol}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">ClientName
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" ype="text"
              name="ClientName" id="ClientName" formControlName="ClientName" required="" aria-required="true"
              [ngClass]="{'cursor-pointer-none' : IsreadOnly}" data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">ClientName </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.ClientName">
                {{displayMessage3.ClientName}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">MQTT Port
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup" name="port"
              id="port" formControlName="port" (keyup)="onKeypressEvent($event, 'MQTTPORT')" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}" OnlyNumber>
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">MQTT Port </span>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.port">
                  {{displayMessage3.port}}
                </p>
                <p class="error_msg error-sms-Interval" *ngIf="MQTTPORTMessage">{{MQTTPORTMessage}}</p>
              </div>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Username
            </label>
            <input class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              type="text" name="MqttUsername" id="MqttUsername" formControlName="MqttUsername" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
              data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Username </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.MqttUsername">
                {{displayMessage3.MqttUsername}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Password
            </label>
            <input class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              type="text" name="MqttPassword" id="MqttPassword" formControlName="MqttPassword" required=""
              aria-required="true" [ngClass]="{'cursor-pointer-none' : IsreadOnly}"
              data-errmsg="Sorry, this is a required field.">
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Password </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.MqttPassword">
                {{displayMessage3.MqttPassword}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">PublishTopic
            </label>
            <input class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              type="text" name="MqttPassword" id="MqttPassword" formControlName="MqttPublishtopic" required=""
              aria-required="true" type="text" name="MqttPublishtopic" id="MqttPublishtopic"
              formControlName="MqttPublishtopic" />
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">PublishTopic </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.MqttPublishtopic">
                {{displayMessage3.MqttPublishtopic}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6  padding-space">
            <label style="display:none;" class="Navuser">Publishdatakey
            </label>
            <input class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              type="text" name="MqttPassword" id="MqttPassword" formControlName="MqttPassword" required=""
              aria-required="true" type="text" name="MqttPublishdatakey" id="MqttPublishdatakey"
              formControlName="MqttPublishdatakey" />
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Publishdatakey</span>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.MqttPublishdatakey">
                  {{displayMessage3.MqttPublishdatakey}}
                </p>
              </div>
            </div>
          </div>        
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Machine SRNo.
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="MachineSRNo" id="MachineSRNo" formControlName="MachineSRNo" required aria-required="true"
              [ngClass]="{'cursor-pointer-none': IsreadOnly}" data-errmsg="Sorry, this is a required field." />
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Machine SRNo. </span>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.MachineSRNo">
                  {{displayMessage3.MachineSRNo}}
                </p>
              </div>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Latitude
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="Latitude" id="Latitude" formControlName="Latitude" required aria-required="true"
              [ngClass]="{'cursor-pointer-none': IsreadOnly}" data-errmsg="Sorry, this is a required field." />
            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Latitude </span>
            <div style="position: relative;">
              <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.Latitude">
                {{displayMessage3.Latitude}}
              </p>
            </div>
          </div>
          <div class="fxg-field margin-top-5 col-lg-6 padding-space">
            <label style="display:none;" class="Navuser">Longitude
            </label>
            <input type="text"
              class="fxg-field__input-text fxg-field__input--required sessioncamexclude width-reduce-popup"
              name="Longitude" id="Longitude" formControlName="Longitude" required aria-required="true"
              [ngClass]="{'cursor-pointer-none': IsreadOnly}" data-errmsg="Sorry, this is a required field." />

            <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Longitude </span>
            <div style="position: relative;">
              <div>
                <p class="error_msg error-sms-Interval" *ngIf="displayMessage3.Longitude">
                  {{displayMessage3.Longitude}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="margin-top-20 button-fix-bottom save-cancel float-right-btn Save-data56" *ngIf="DisplayButton">
        <button class="btncommon  width-fix67 btn-orange-SendToMail12" (click)="OnSubmitSettings()"
          id="btngsmconfigSave">Save</button>
        <button class="btncommon-grey btn-border-add-company  width-fix67" (click)="OnCancel()"
          id="btngsmconfigCancel">Cancel</button>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>